import { useState, useEffect } from 'react'

// services
import { fetchGroup } from '../../services/groups'

const useGroup = (groupId) => {
  const [group, setGroup] = useState({})
  const [isLoading, setIsLoading] = useState(true)

  const getGroup = async () => {
    setIsLoading(true)
    try {
      const response = await fetchGroup(groupId)
      const updatedGroup = response?.data || {}
      const normalizedGroup = {
        ...updatedGroup,
        stats: {
          ...updatedGroup.stats,
          totalMemberCount:
            updatedGroup.members?.length ??
            updatedGroup.stats?.totalMemberCount,
        },
      }
      setGroup(normalizedGroup)
    } catch (error) {
      // toast.error(error.message)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (groupId) {
      getGroup()
    }
  }, [groupId])

  return { group, isGroupLoading: isLoading, getGroup, setGroup }
}

export default useGroup
